




















































































































































































import Component, { mixins } from "vue-class-component";
import { State, namespace } from "vuex-class";
import TextDayChangePicker from "@/components/common/TextDayChangePicker.vue";
import TextMonthChangePicker from "@/components/common/TextMonthChangePicker.vue";
import MonthMultiplePicker from "@/components/common/MonthMultiplePicker.vue";
import MonthPickerDialog from "@/components/common/MonthPickerDialog.vue";
import BaseTable, {
  StringKeyObject,
  CallbackItemStatus,
  CallbackItemClass
} from "@/components/common/BaseTable.vue";
import InterbankDate, {
  InterbankDateItem
} from "../components/userInvoice/InterbankDate.vue";
import AxiosMixin from "../mixins/axiosMixin";
import { HeaderWidthItem, dateJp, getStorageNumber, parseComma } from "@/types";
import { Ref, Watch } from "vue-property-decorator";
import LoadingDialog from "../components/common/LoadingDialog.vue";
import { YearmonthState, SET_YEARMONTH } from "@/store/modules/yearmonth/types";
import {
  YearmonthsState,
  SET_YEARMONTHS
} from "@/store/modules/yearmonths/types";
import RadioGroupDialog from "@/components/common/RadioGroupDialog.vue";
import SelectDialog from "@/components/common/SelectDialog.vue";
import { AxiosResponse } from "axios";
import SelectFilter, { ColumnKey } from "@/components/common/SelectFilter.vue";
import { UserInvoiceModel, DefaultUserInvoiceModel } from "@/model/userinvoice";
import DayPickerDialog from "@/components/common/DayPickerDialog.vue";

const StoreYearmonth = namespace("yearmonth");
const StoreYearmonths = namespace("yearmonths");

@Component({
  components: {
    TextMonthChangePicker,
    BaseTable,
    InterbankDate,
    LoadingDialog,
    TextDayChangePicker,
    MonthMultiplePicker,
    RadioGroupDialog,
    SelectDialog,
    SelectFilter,
    MonthPickerDialog,
    DayPickerDialog
  }
})
export default class UserInvoice extends mixins(AxiosMixin) {
  @Ref("baseTable") private readonly baseTable!: BaseTable;

  @Ref("interbankDialog") private readonly interbankDialog!: InterbankDate;
  @Ref("previewTypeDialog")
  private readonly previewTypeDialog!: RadioGroupDialog;
  @Ref("printTypeDialog") private readonly printTypeDialog!: RadioGroupDialog;
  @Ref("selectDialog")
  private readonly selectDialog!: SelectDialog;
  @Ref("selectFilter") private readonly selectFilter!: SelectFilter;

  @Ref("csvTypeDialog") private readonly csvTypeDialog!: RadioGroupDialog;

  @State("yearmonth") yearmonthState!: YearmonthState;
  @StoreYearmonth.Mutation(SET_YEARMONTH) setYearmonth!: Function;
  private get yearmonth() {
    return this.yearmonthState.yearmonth;
  }
  private set yearmonth(yearmonth: string) {
    this.setYearmonth(yearmonth);
  }

  @State("yearmonths") yearmonthsState!: YearmonthsState;
  @StoreYearmonths.Mutation(SET_YEARMONTHS) setYearmonths!: Function;
  private get storeYearmonths() {
    return this.yearmonthsState.yearmonths;
  }
  private set storeYearmonths(yearmonths: string[]) {
    localStorage.setItem("yearmonths", JSON.stringify(yearmonths));
    this.setYearmonths(yearmonths);
  }
  private yearmonths: string[] = [];

  private historys = [];
  private isActiveHistory = false;
  private selectHistory: { id: number; updated_at?: string } = {
    id: 0
  };
  private historyPatient: { id: number; name: string } = { id: 0, name: "" };

  private isActiveMonthPicker = false;
  private isActiveDayPickerForPdf = false;
  private isActiveDayPickerForExportPayAccount = false;

  private pdfSetting: {
    printType: number;
    isDownload: boolean;
    isHistory: boolean;
  } = { printType: 0, isDownload: false, isHistory: false };
  private item: InterbankDateItem = { yearmonth: "" };

  private is_csv_output_enabled = 0;
  private is_csv_disable_labels: number[] = [];

  private comletedItems = [
    {
      value: 0,
      text: "未作成"
    },
    {
      value: 1,
      text: "作成済"
    }
  ];

  private headerItems: HeaderWidthItem[] = [
    {
      value: "edit",
      text: "編集",
      width: "80px"
    },
    {
      value: "history",
      text: "履歴",
      width: "80px"
    },
    {
      value: "printed_at",
      text: "請求データ確定済日",
      width: "102px"
    },
    {
      value: "processed_at",
      text: "処理済日",
      width: "102px"
    },
    {
      value: "claim_settled",
      text: "請求済出力方法",
      width: "130px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("claim_settled", val)
    },
    {
      value: "payment_method",
      text: "支払方法",
      width: "98px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("payment_method", val)
    },
    {
      value: "invoice_amount",
      text: "請求金額",
      width: "98px",
      filterType: SelectFilter.FILTER_TYPE_NUMBER,
      filter: (val: object) => this.columnFilter("invoice_amount", val)
    },
    {
      value: "ibow_id",
      text: "利用者ID",
      width: "98px",
      filter: (val: object) => this.columnFilter("ibow_id", val)
    },
    {
      value: "insured_no",
      text: "被保険者番号",
      width: "122px",
      filter: (val: object) => this.columnFilter("insured_no", val)
    },
    {
      value: "name",
      text: "氏名",
      width: "140px",
      filter: (val: object) => this.columnFilter("name", val)
    },
    {
      value: "furigana",
      text: "ﾌﾘｶﾞﾅ",
      width: "140px",
      filter: (val: object) => this.columnFilter("furigana", val)
    },
    {
      value: "insurance_no",
      text: "保険者番号",
      width: "110px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_no", val)
    },
    {
      value: "insurance_name",
      text: "保険者名",
      width: "190px",
      filterType: SelectFilter.FILTER_TYPE_EDIT_LIST,
      filter: (val: object) => this.columnFilter("insurance_name", val)
    },
    {
      value: "is_medical",
      text: "医療",
      width: "56px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_medical", val)
    },
    {
      value: "is_care",
      text: "介護",
      width: "56px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_care", val)
    },
    {
      value: "is_own_expense",
      text: "自費",
      width: "56px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("is_own_expense", val)
    },
    {
      value: "yearmonth",
      text: "サービス提供年月",
      width: "108px",
      filterType: SelectFilter.FILTER_TYPE_LIST,
      filter: (val: object) => this.columnFilter("yearmonth", val)
    }
  ];

  get filteredTableItems(): object[] {
    // selectFilter が未設定の場合はそのまま全件返す
    if (!this.selectFilter) {
      return this.tableItems;
    }
    const clauses = this.selectFilter.filterClauses;
    if (!clauses || clauses.length === 0) {
      return this.tableItems;
    }
    return this.tableItems.filter(item => {
      return clauses.every(clause => {
        // item[clause.colKey.key] が存在しない場合は空文字とする
        const value = item[clause.colKey.key] || "";
        return this.selectFilter.isMatch(clause.colKey.key, value);
      });
    });
  }

  //------------------------------------------
  // SelectFilterの選択肢
  //------------------------------------------
  private get columnKeys(): ColumnKey[] {
    // headerItems からフィルター対象の columnKeys を生成
    const keys: ColumnKey[] = this.headerItems
      .filter(hditm => hditm.filter != null)
      .map(hditm => {
        let type = SelectFilter.FILTER_TYPE_EDIT;
        if (hditm.filterType != null) {
          type = hditm.filterType;
        }
        let selectable = null;
        if (
          hditm.filterType === SelectFilter.FILTER_TYPE_LIST ||
          hditm.filterType === SelectFilter.FILTER_TYPE_EDIT_LIST
        ) {
          // 選択肢一覧作成
          selectable = this.tableItems
            .map(itm => {
              const txt = (itm as any)[hditm.value];
              return txt === "" ? SelectFilter.NO_DATA : txt;
            })
            .filter((val, idx, arr) => {
              return arr.indexOf(val) === idx;
            });
          // NO_DATAラベルを一覧の先頭に移動
          const idx = selectable.indexOf(SelectFilter.NO_DATA);
          if (idx > 0) {
            this.moveAt(selectable, idx, 0);
          }
        }
        const fkey: ColumnKey = {
          type: type,
          key: hditm.value,
          text: hditm.text,
          selectable: selectable
        };
        return fkey;
      });

    // フィルターのみに表示する項目（処理済日あり/なし）
    const newFilterKey1: ColumnKey = {
      type: SelectFilter.FILTER_TYPE_LIST,
      key: "is_printed",
      text: "請求データ確定済日",
      selectable: ["データなし", "データあり"]
    };
    this.insertCustomKey(keys, newFilterKey1, "");

    const newFilterKey2: ColumnKey = {
      type: SelectFilter.FILTER_TYPE_LIST,
      key: "is_exec_text",
      text: "処理済日",
      selectable: ["データなし", "データあり"]
    };
    this.insertCustomKey(keys, newFilterKey2, "is_printed");

    return keys;
  }

  private insertCustomKey(
    keys: ColumnKey[],
    insertKey: ColumnKey,
    afterKeyName: string
  ) {
    if (afterKeyName === "") {
      // 空文字の場合は先頭に追加
      keys.unshift(insertKey);
    } else {
      const index = keys.findIndex(k => k.key === afterKeyName);
      if (index >= 0) {
        // 指定の位置に追加
        keys.splice(index + 1, 0, insertKey);
      } else {
        // 見つからなければ末尾に追加
        keys.push(insertKey);
      }
    }
  }

  //------------------------------------------
  // カラムフィルター
  //------------------------------------------
  private columnFilter(key: string, val: object) {
    const bret = this.selectFilter.isMatch(key, val);

    // テーブル更新
    if (this.baseTable) {
      this.baseTable.handle();
    }
    return bret;
  }

  private tableItems: { [key: string]: any }[] = [];

  private objectIds: StringKeyObject[] = []; //選択対象ID

  private invoiceYMD: string = dateJp(new Date()).substr(0, 10); //請求書日付
  private receiptYMD: string = dateJp(new Date()).substr(0, 10); //領収書日付

  private isTrial = window.is_trial;

  mounted() {
    this.yearmonths =
      JSON.parse(String(localStorage.getItem("yearmonths"))) ||
      this.storeYearmonths;
    // 画面復帰設定（チェックボックス、フィルタ条件）
    if (!this.$route.query.st) {
      this.baseTable.clearAllCheck();
      this.selectFilter.clearAll();
    } else {
      this.baseTable.restoreStorage();
      this.selectFilter.restoreStorage();
    }
    // 画面更新
    this.updateData();
  }

  private updateData() {
    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/get",
      {
        yearmonths: this.yearmonths
      },
      res => {
        this.tableItems = res.data.invoices;
        this.OfficeId = res.data.office_id;
        this.UseEdiFlg = res.data.use_edi_flg;
        this.EdiCode = res.data.edi_code;
        this.EdiName = res.data.edi_name;
        this.SubstituteMonth = res.data.substitute_month;
        this.SubstituteDay = res.data.substitute_day;
        this.is_csv_output_enabled = res.data.is_csv_output_enabled;
        this.is_csv_disable_labels = res.data.is_csv_disable_labels;
        this.$router.replace(`/userinvoice?st=1`).catch(err => err);
        this.$nextTick(() => {
          this.baseTable.restoreStorage();
          this.baseTable.updateBaseTable();
        });
      }
    );
  }

  private search() {
    this.storeYearmonths = this.yearmonths;
    this.baseTable.clearAllCheck();
    this.updateData();
  }

  //------------------------------------------
  // 帳票プレビューボタンクリクイベント
  //------------------------------------------
  private clickPreview(objectIds: StringKeyObject[]) {
    const url = window.base_url + "/api/office/userinvoice/specification/check";
    const requestParams = this.baseTable.SelectedItems().map(item => {
      return {
        patient_id: item.patient_id,
        patient_name: item.name,
        invoice_id: item.id,
        yearmonth: item.ym
      };
    });

    this.postJsonCheck(
      url,
      {
        patient_yearmonths: requestParams
      },
      res => {
        // 事業所、年月、利用者、保険者が複数存在する場合、警告メッセージを表示
        console.log(res.data.overlap_insurance);
        if (res.data.overlap_insurance) {
          if (
            !confirm(
              "[医療請求管理]もしくは[介護請求管理]の請求データが重複している利用者が含まれています。\nこのまま出力すると、利用者への請求額も重複して出力される可能性があります。\n\n※[医療請求管理]もしくは[介護請求管理]で再集計をすれば重複したデータが正しく出力できます。\n※請求データを確認し直す場合はキャンセルしてください。\n\n再集計せずにこのまま出力しますか？"
            )
          ) {
            return;
          }
        }
        const type = getStorageNumber("userinv-preview-type");
        this.previewTypeDialog.open(type);
      }
    );
  }

  //------------------------------------------
  // 帳票プレビューボタン印刷タイプ選択イベント
  //------------------------------------------
  private previewPdfTypeOK(type: number) {
    localStorage.setItem("userinv-preview-type", type.toString());
    this.requestCreatePdf(type, false, false);
  }

  //------------------------------------------
  // PDF印刷ボタンクリクイベント
  //------------------------------------------
  private clickPrintPdf() {
    const url = window.base_url + "/api/office/userinvoice/specification/check";
    const requestParams = this.baseTable.SelectedItems().map(item => {
      return {
        patient_id: item.patient_id,
        patient_name: item.name,
        invoice_id: item.id,
        yearmonth: item.ym
      };
    });

    this.postJsonCheck(
      url,
      {
        patient_yearmonths: requestParams
      },
      res => {
        // 事業所、年月、利用者、保険者が複数存在する場合、警告メッセージを表示
        if (res.data.overlap_insurance) {
          if (
            !confirm(
              "[医療請求管理]もしくは[介護請求管理]の請求データが重複している利用者が含まれています。\nこのまま出力すると、利用者への請求額も重複して出力される可能性があります。\n\n※[医療請求管理]もしくは[介護請求管理]で再集計をすれば重複したデータが正しく出力できます。\n※請求データを確認し直す場合はキャンセルしてください。\n\n再集計せずにこのまま出力しますか？"
            )
          ) {
            return;
          }
        }

        if (this.baseTable.confirmAllSelect() === false) {
          return;
        }
        const type = getStorageNumber("userinv-print-type");
        this.printTypeDialog.open(type);
      }
    );
  }

  //------------------------------------------
  // PDF印刷ボタン印刷タイプ選択イベント
  //------------------------------------------
  private printPdfTypeOK(type: number) {
    localStorage.setItem("userinv-print-type", type.toString());
    this.requestCreatePdf(type, true, false);
  }

  //------------------------------------------
  // PDF作成リクエスト
  //------------------------------------------
  private async requestCreatePdf(
    printType: number,
    isDownload: boolean,
    isHistory: boolean
  ) {
    if (isDownload) {
      if (
        !confirm(
          "処理済みにしますか？\nキャンセルにするとダウンロードされません。"
        )
      ) {
        return;
      }
      this.pdfSetting = {
        printType: printType,
        isDownload: isDownload,
        isHistory: isHistory
      };
      this.isActiveDayPickerForPdf = true;
      return;
    } else {
      this.exportPdf(printType, isDownload, isHistory);
    }
  }

  private async exportPdf(
    printType: number,
    isDownload: boolean,
    isHistory: boolean,
    date = ""
  ) {
    if (!date) {
      date = this.Today;
    }

    // チェックitem取得
    const url = window.base_url + "/api/office/userinvoice/pdf";
    // 画面並び順でチェック項目を取得するために、
    // フィルタ解除->取得->再フィルタ処理を行う。
    this.selectFilter.clearExceptStorage();
    await this.$nextTick();

    const targets = isHistory
      ? [
          {
            id: this.selectHistory.id,
            patient_id: this.historyPatient.id,
            name: this.historyPatient.name
          }
        ]
      : this.baseTable.SelectedItems().map(item => {
          return {
            id: item.id,
            updated_at: item.updated_at,
            patient_id: item.patient_id,
            name: item.name
          };
        });
    this.selectFilter.restoreStorage();
    await this.$nextTick();

    // 全アイテムが処理済みかどうか
    const finalized =
      this.baseTable.SelectedItems().filter(item => {
        return !String(item.claim_settled).includes("PDF出力");
      }).length == 0;

    const params = {
      targets: targets,
      is_finalize: isDownload ? 1 : 0,
      invoice_ymd: this.invoiceYMD,
      receipt_ymd: this.receiptYMD,
      print_type: printType,
      history: isHistory ? 1 : 0,
      finalized,
      exec_ymd: date
    };
    // PDF作成、URL取得
    this.postJsonCheck(url, params, res => {
      if (isDownload) {
        // ファイルダウンロード
        const fname = this.savePdfFileName(printType);
        this.saveFileWithUrl(res.data.pdf_path, fname);
        this.updateData();
      } else {
        // プレビュー表示
        window.open(res.data.pdf_path);
      }
    });
  }

  //------------------------------------------
  // ファイル保存
  //------------------------------------------
  private saveFileWithUrl(url: string, fname: string) {
    this.loading = true;
    window.axios
      .get(url, { responseType: "blob" })
      .then((response: AxiosResponse) => {
        const blob = new Blob([response.data]);
        const a = document.createElement("a");
        a.download = fname;
        a.href = URL.createObjectURL(blob);
        a.click();
        this.loading = false;
      })
      .catch((error: { response: any }) => {
        this.loading = false;
        alert("サーバでエラーが発生しました。");
        console.log(error);
        console.log(error.response);
      });
  }

  //------------------------------------------
  // 保存ファイル名
  //------------------------------------------
  private savePdfFileName(printType: number) {
    let typename = "請求書";
    switch (printType) {
      case 0:
        typename = "請求書";
        break;
      case 1:
        typename = "領収書兼明細書";
        break;
      case 2:
        typename = "請求書・領収書兼明細書";
        break;
    }
    const fname = `利用者-${typename}.pdf`;
    return fname;
  }

  //------------------------------------------
  // 請求データ確定処理
  //------------------------------------------
  private async checked(items: StringKeyObject[]) {
    const url = "/api/office/userinvoice/checked";
    // 画面並び順でチェック項目を取得するために、
    // フィルタ解除->取得->再フィルタ処理を行う。
    this.selectFilter.clearExceptStorage();
    await this.$nextTick();
    const targets = this.baseTable.SelectedItems().filter(item => {
      return { id: item.id, updated_at: item.updated_at };
    });

    this.selectFilter.restoreStorage();
    await this.$nextTick();
    const param = {
      targets: targets
    };
    this.postJsonCheck(window.base_url + url, param, () => {
      this.updateData();
    });
  }

  //------------------------------------------
  // 取消
  //------------------------------------------
  private cancel(items: StringKeyObject[]) {
    const ids: object[] = [];
    items.forEach(item => {
      ids.push(item.id);
    });
    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/cancel",
      {
        ids: ids,
        patients: items.map(item => ({ id: item.patient_id, name: item.name }))
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  // 利用者請求データ削除
  //------------------------------------------
  private deletedata(items: UserInvoiceModel[]) {
    //確認
    if (
      !confirm(
        "利用者請求データの削除を行います。請求データ確定済もしくは請求処理済データは処理対象外です。よろしいですか？"
      )
    ) {
      return;
    }

    //選択されたデータを請求データ処理済・請求処理済以外に絞る
    const targetDatas: UserInvoiceModel[] = [];
    for (const item of items) {
      if (item.is_printed == "データなし" && item.is_exec == "0") {
        targetDatas.push(item);
      }
    }
    //処理対象がない場合
    if (targetDatas.length === 0) {
      alert("処理対象がありません。");
      return;
    }

    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/delete",
      {
        targets: targetDatas,
        patients: targetDatas.map(item => ({
          id: item.patient_id,
          name: item.name,
          invoice_id: item.id,
          yearmonth: item.yearmonth
        }))
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  // 利用者請求作成
  //------------------------------------------
  private clickCreateUserInvoice() {
    this.isActiveMonthPicker = true;
  }
  private onCancelMonthPicker() {
    this.isActiveMonthPicker = false;
  }
  private createUserInvoice(yearmonth: string) {
    //確認
    if (
      !confirm(
        "対象年月の利用者請求を作成します。請求データ確定済もしくは、請求処理済ではないデータは最新の状態に上書きされます。よろしいですか？"
      )
    ) {
      return;
    }

    const ids: object[] = [];
    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/save_userinvoice",
      {
        yearmonth: yearmonth
      },
      () => {
        this.updateData();
        this.isActiveMonthPicker = false;
      }
    );
  }

  private OfficeId = ""; //事業所ID
  private UseEdiFlg = 0; //集金代行サービス利用フラグ（0:利用しない 1:利用する）
  private EdiCode = ""; //委託者コード
  private EdiName = ""; //委託者名
  private SubstituteMonth = ""; //振替年月
  private SubstituteDay = ""; //振替日

  //------------------------------------------
  //口座振替データ出力ボタン
  //------------------------------------------
  private interbankFormat(objectIds: StringKeyObject[]) {
    //未選択の場合処理しない
    if (objectIds.length == 0) {
      return;
    }

    //集金代行サービスを利用しない場合アラート
    if (this.UseEdiFlg == 0) {
      alert(
        "現在、集金代行サービスを使用しないに設定されています。使用される場合は、iBowの事業所情報登録より設定変更してください。"
      );
      return;
    }

    //引落対象レコード取得
    const targets = this.debitTarget(objectIds);

    //選択された利用者に引落がいなければアラート
    if (targets.length == 0) {
      alert(
        "支払方法に「引落」を設定している利用者を選択していないため、口座振替データ出力はできません。"
      );
      return;
    }

    //請求金額がマイナスの利用者
    const minusUsers = targets.filter(item => {
      return (item as any).request_the_amount_flg === 1;
    });

    //請求金額がマイナスの利用者がいる場合アラート
    if (minusUsers.length != 0) {
      let userName = "";
      //3人未満の場合
      if (minusUsers.length < 3) {
        for (let i = 0; i < minusUsers.length; i++) {
          userName += minusUsers[i].name + "、";
        }
        alert(
          "引落金額にマイナスの利用者が存在します。確認してください。氏名：" +
            userName.slice(0, -1)
        );
        return;
      }
      //3人以上の場合（語尾に”など”つける）
      if (minusUsers.length >= 3) {
        for (let i = 0; i < 3; i++) {
          userName += minusUsers[i].name + "、";
        }
        alert(
          "引落金額にマイナスの利用者が存在します。確認してください。氏名：" +
            userName.slice(0, -1) +
            " など"
        );
        return;
      }
    }

    this.interbankDialog.open();

    this.interbankDialog.yearmonth = this.SubstituteMonth;
    this.interbankDialog.day = this.SubstituteDay;
    this.objectIds = targets;
  }

  //口座振替データ出力
  private Display(item: InterbankDateItem) {
    if (confirm("請求処理済みにしますか？")) {
      this.item = item;
      this.isActiveDayPickerForExportPayAccount = true;
      return;
    }
    this.exportPaymentTransferData(item, false);
  }

  //口座振替データ出力
  private exportPaymentTransferData(
    item: InterbankDateItem,
    isFinalize: boolean,
    date = ""
  ) {
    if (!date) {
      date = this.Today;
    }
    const targets: StringKeyObject[] = this.debitTarget(this.objectIds);
    const fname = `全銀フォーマット${item.yearmonth.replace("-", "")}${
      this.SubstituteDay
    }.txt`;
    const targetData = targets.map(item => {
      return {
        id: item.id,
        updated_at: item.updated_at,
        patient_id: item.patient_id,
        name: item.name
      };
    });
    const url = "/api/office/userinvoice/interbankFormat";
    const param = {
      targets: targetData,
      is_finalize: isFinalize ? 1 : 0,
      edi_code: this.EdiCode,
      edi_name: this.EdiName,
      substitute_yearmonth: item.yearmonth,
      substitute_day: this.SubstituteDay,
      exec_ymd: date
    };
    this.postJsonBlobRes(window.base_url + url, param, async res => {
      const alertFlg = res.headers["x-data-alert"];
      if (alertFlg == "1") {
        // alertFlg が１の場合アラートを表示するため、レスポンスを文字列に戻して表示
        const data = res.data;
        const text = await data.text();
        const json = JSON.parse(text); // 改行コードが文字列なのでパース
        alert(json);
        return;
      }
      if (isFinalize) {
        this.updateData();
      }
      const blob = new Blob([res.data]);
      const a = document.createElement("a");
      a.download = fname;
      a.href = URL.createObjectURL(blob);
      a.click();
      const count = res.headers["x-data-count"];
      const amount = res.headers["x-data-amount"];
      const title = "【合計件数・合計金額】";
      const message = `件数：${count}件\n金額：${parseComma(amount)}円`;
      await this.$alert(title, message);
    });
  }

  //-----------------------------
  // 引落対象レコード取得
  //-----------------------------
  private debitTarget(objectIds: StringKeyObject[]) {
    const arr: StringKeyObject[] = [];
    objectIds.forEach(item => {
      if ((item as any).payment_method.endsWith("引落")) {
        arr.push(item);
      }
    });
    return arr;
  }

  //------------------------------------------
  //請求処理済チェック
  //------------------------------------------
  private claimSettledChecked(objectIds: StringKeyObject[]) {
    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/claimsettledchecked",
      {
        ids: objectIds.map(objectId => objectId.id)
      },
      () => {
        this.updateData();
      }
    );
  }

  //------------------------------------------
  //備考編集
  //------------------------------------------
  private edit(item: StringKeyObject) {
    this.$router.push({
      path:
        "/userinvoice/edit/" +
        item.id +
        "?patient_id=" +
        item.patient_id +
        "&patient_name=" +
        encodeURIComponent(String(item.name))
    });
  }

  //------------------------------------------
  //履歴取得する
  //------------------------------------------
  private history(item: StringKeyObject) {
    this.historyPatient = {
      id: (item.patient_id as unknown) as number,
      name: (item.name as unknown) as string
    };
    this.postJsonCheck(
      window.base_url + "/api/office/userinvoice/get_historys",
      {
        patient_ids: [item.patient_id],
        yearmonth: item.ym,
        patients: [{ id: item.patient_id, name: item.name }]
      },
      res => {
        this.historys = res.data.historys;
        this.isActiveHistory = true;
      }
    );
  }

  private get OnChangeHistory() {
    return this.historys;
  }

  private onSelecHistory(item: { id: number; updated_at: string }) {
    this.selectHistory = item;
    this.isActiveHistory = false;
    this.requestCreatePdf(0, false, true);
  }

  private onCancelHistory() {
    this.isActiveHistory = false;
  }

  //-----------------------------
  // 行の状態コールバック   0:未処理、1:確定済、2:確定済かつ処理済
  //-----------------------------
  public itemStatus: CallbackItemStatus = (item: any) => {
    const isPrinted = (item as any).is_printed as string;
    const isExec = (item as any).is_exec as string;
    if (isExec === "1") {
      return 2;
    }
    if (isPrinted == "データあり") {
      return 1;
    }
    return 0;
  };

  //-----------------------------
  // 行の背景コールバック   complete返却で背景グレー
  //-----------------------------
  public itemClass: CallbackItemClass = (item: any) => {
    const isExec = (item as any).is_exec as string;
    if (isExec === "1") {
      return "complete";
    }
    return "";
  };

  //------------------------------------------
  // 配列要素の移動
  //------------------------------------------
  private moveAt(array: object[], idx: number, at: number) {
    if (idx === at || idx > array.length - 1 || at > array.length - 1) {
      return;
    }
    const value = array[idx];
    const tail = array.slice(idx + 1);
    array.splice(idx);
    Array.prototype.push.apply(array, tail);
    array.splice(at, 0, value);
  }

  //------------------------------------------
  // CSV作成リクエスト
  //------------------------------------------
  private clickOutputCsv() {
    const url = window.base_url + "/api/office/userinvoice/specification/check";
    const requestParams = this.baseTable.SelectedItems().map(item => {
      return {
        patient_id: item.patient_id,
        patient_name: item.name,
        invoice_id: item.id,
        yearmonth: item.ym
      };
    });

    this.postJsonCheck(
      url,
      {
        patient_yearmonths: requestParams
      },
      res => {
        // 事業所、年月、利用者、保険者が複数存在する場合、警告メッセージを表示
        if (res.data.overlap_insurance) {
          if (
            !confirm(
              "[医療請求管理]もしくは[介護請求管理]の請求データが重複している利用者が含まれています。\nこのまま出力すると、利用者への請求額も重複して出力される可能性があります。\n\n※[医療請求管理]もしくは[介護請求管理]で再集計をすれば重複したデータが正しく出力できます。\n※請求データを確認し直す場合はキャンセルしてください。\n\n再集計せずにこのまま出力しますか？"
            )
          ) {
            return;
          }
        }

        if (this.baseTable.confirmAllSelect() === false) {
          return;
        }
        let type = getStorageNumber("userinv-csv-type");
        if (this.is_csv_disable_labels.includes(type)) {
          if (!this.is_csv_disable_labels.includes(0)) {
            type = 0;
          }
          if (!this.is_csv_disable_labels.includes(1)) {
            type = 1;
          }
        }
        this.csvTypeDialog.open(type);
      }
    );
  }

  //------------------------------------------
  // CSV作成ボタン印刷タイプ選択イベント
  //------------------------------------------
  private printCsvTypeOK(type: number) {
    localStorage.setItem("userinv-csv-type", type.toString());
    this.requestCreateCsv(type, true);
  }

  //------------------------------------------
  // PDF作成リクエスト
  //------------------------------------------
  private async requestCreateCsv(printType: number, isDisplay: boolean) {
    // チェックitem取得
    const url = window.base_url + "/api/office/userinvoice/csv";
    // 画面並び順でチェック項目を取得するために、
    // フィルタ解除->取得->再フィルタ処理を行う。
    this.selectFilter.clearExceptStorage();
    await this.$nextTick();

    const targets = this.baseTable.SelectedItems().map(item => {
      return {
        id: item.id,
        updated_at: item.updated_at,
        patient_id: item.patient_id,
        name: item.name
      };
    });
    this.selectFilter.restoreStorage();
    await this.$nextTick();

    const params = {
      targets: targets,
      invoice_ymd: this.invoiceYMD,
      receipt_ymd: this.receiptYMD,
      print_type: printType,
      history: 0
    };
    // PDF作成、URL取得
    this.postJsonCheck(url, params, () => {
      // ファイルダウンロード
      if (isDisplay) {
        alert("CSVが出力されました。");
      }
    });
  }

  private download(blobable: Blob, fileName: string): void {
    if (!blobable.size) return;
    const blob = new Blob([blobable]);
    const a = document.createElement("a");
    a.download = fileName;
    a.href = URL.createObjectURL(blob);
    a.click();
  }

  /** ファイル名取得 */
  private getFileName(
    res: AxiosResponse<unknown>,
    defaultFileName = "downloaded_file"
  ): string {
    const contentDisposition = res.headers["content-disposition"];
    let filename = defaultFileName; // デフォルトのファイル名
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(
        /filename\*?=['"]?(?:UTF-8''|)([a-zA-Z0-9%._ -]+)"?/i
      );
      if (filenameMatch && filenameMatch[1]) {
        try {
          // URLデコードして日本語などの文字化けを修正
          filename = decodeURIComponent(filenameMatch[1]);
        } catch (e) {
          console.warn("ファイル名のデコードに失敗しました:", e);
          filename = filenameMatch[1]; // デコード失敗時はそのまま使用
        }
      }
    }
    return filename;
  }

  // 処理済み日設定ダイアログを閉じる
  private closeDayPickerForPdf() {
    this.isActiveDayPickerForPdf = false;
  }

  // 処理済み日設定ダイアログで日付を設定する
  private selectDayForPdf(date: string) {
    this.exportPdf(
      this.pdfSetting.printType,
      this.pdfSetting.isDownload,
      this.pdfSetting.isHistory,
      date
    );
    this.closeDayPickerForPdf();
  }

  // 処理済み日設定ダイアログを閉じる
  private closeDayPickerForExportPayAccount() {
    this.isActiveDayPickerForExportPayAccount = false;
  }

  // 処理済み日設定ダイアログで日付を設定する
  private selectDayForExportPayAccount(date: string) {
    this.exportPaymentTransferData(this.item, true, date);
    this.closeDayPickerForExportPayAccount();
  }

  //リアルタイム今日
  private get Today(): string {
    const date = new Date();
    date.setTime(date.getTime() + 1000 * 60 * 60 * 9);
    date.setDate(date.getDate());
    const today = date.toISOString().substr(0, 10);
    return today;
  }
}
